module.exports = __webpack_public_path__ + "img/sec3_lang_center.fcb9e76d.png";